export const ONE_SECOND_MS = 1000;
export const ONE_MINUTE_MS = ONE_SECOND_MS * 60;
export const ONE_MINUTE_SEC = 60;
export const ONE_HOUR_MS = ONE_MINUTE_MS * 60;
export const ONE_HOUR_MIN = 60;
export const ONE_DAY_MS = ONE_HOUR_MS * 24;
export const ONE_WEEK_MS = ONE_DAY_MS * 7;
